import type { Pt } from '../core/geometry'

/**
 * Append a closed polygon to a `Path2D` — `tracePoly` from `core/geometry`,
 * but into a retained path rather than the context's current one.
 *
 * Here and not in `core/geometry` because `Path2D` is a DOM object and `core/`
 * has none. Both renderers build their settled strands into one of these once
 * and fill it on every frame after (docs/performance-audit.md, findings 2 and
 * 8); the shape of the polygon is still the geometry module's business.
 */
export function addPoly(path: Path2D, poly: Pt[]) {
  if (!poly.length) return
  path.moveTo(poly[0]!.x, poly[0]!.y)
  for (let i = 1; i < poly.length; i++) path.lineTo(poly[i]!.x, poly[i]!.y)
  path.closePath()
}
